export default __webpack_public_path__ + "static/char-s-41-zh-Hant-27d7a63eeda48be58c23d154489b2027.png";